import styled from "styled-components";
import { theme } from "@theme";
import { Typography } from "@atoms";

export const MobileWrapper = styled.div`
  position: fixed !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #FFFBF8 !important;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: auto;
  z-index: 99999;

  > button {
    width: 100%;
    padding: 12px;
    font-size: 16px;
  }
`;

export const AddPeopleContentTitle = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  background: #F9F2EC;
  height: 60px;
  padding: 16px;

  img {
    width: 12px;
    height: 12px;
  }
`

export const AddPeopleContentButtons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  position: fixed !important;
  z-index: 10;
  bottom: 0;
  left: 0;
  right: 0;
  height: 76px;
  background: #F9F2EC;
  border-top: 1px solid #F9F2EC;
  border-bottom: 1px solid #F9F2EC;
  padding: 0 16px;
  > button {
    width: 100%;
    padding: 12px;
    font-size: 16px;
  }
`

export const AddPeopleContentWrapper = styled.div`
  display: grid;
  grid-template-columns: 322px 1fr 1px 1fr;
  gap: 24px;
  padding: 38px 26px;

  .add-people-content {
    display: flex;
    flex-direction: column;
    
    @media screen and (max-width: ${theme.breakpoints.sm}) {
      align-items: center;
    }
  }

  @media screen and (max-width: ${theme.breakpoints.sm}) {
    display: flex;
    flex-direction: column;
    padding: 38px 26px 80px 26px;
  }
`;

export const SwitchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  cursor: pointer;
  position: relative;
`

export const SwitchText = styled(Typography)`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const SwitchTooltip = styled.button`
  display: flex;
  background: none;
  border: none;
`

export const DividerVertical = styled.div`
  width: 1px;
  margin: 16px 0;
  background: #E4D7CD;
`;

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  margin: 16px 0;
  background: #E4D7CD;
`;

export const BrowseContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 18px;
  justify-content: center;
  align-items: center;
  width: 322px;
  height: 440px;
  background: rgba(178, 155, 132, 0.3);
  border: 1px dashed rgba(0, 0, 0, 0.3);
  border-radius: 6px;
`;

export const Cryonized = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  position: absolute !important;
  top: 13px;
  left: 13px;
  border: 1px solid rgba(88, 189, 255, 0.50);
  background: #71B8E6;
  box-shadow: 0px 10px 6px 0px rgba(255, 255, 255, 0.30) inset;
  border-radius: 6px;
  padding: 7px 10px;
  color: #ffffff;
  width: 139px;
  height: 32px;

  img {
    width: 18px !important;
    height: 18px !important;
  }
`;

export const PreviewWrapper = styled.div`
  position: relative;
  height: 440px;
  cursor: pointer;
  img {
    width: 322px;
    height: 440px;
    border-radius: 6px;
  }

  &:hover .preview-hover {
    opacity: 1;
  }
  
  .preview-hover {
    border-radius: 6px;
    opacity: 0;
    display: flex;
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, .3);
    flex-direction: column;
    justify-content: center;
    align-items: center;

    img {
      width: 100px;
      height: 100px;
    }
  }
`
